"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    swatchPickerRowClassNames: function() {
        return swatchPickerRowClassNames;
    },
    useSwatchPickerRowStyles_unstable: function() {
        return useSwatchPickerRowStyles_unstable;
    }
});
const _react = require("@griffel/react");
const swatchPickerRowClassNames = {
    root: 'fui-SwatchPickerRow'
};
/**
 * Styles for the root slot
 */ const useResetStyles = /*#__PURE__*/ (0, _react.__resetStyles)("r1xhj18k", null, [
    ".r1xhj18k{display:flex;flex-direction:row;}"
]);
const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    spacingSmall: {
        i8kkvl: "f16mnhsx"
    },
    spacingMedium: {
        i8kkvl: "f1q8lukm"
    }
}, {
    d: [
        ".f16mnhsx{column-gap:2px;}",
        ".f1q8lukm{column-gap:4px;}"
    ]
});
const useSwatchPickerRowStyles_unstable = (state)=>{
    'use no memo';
    const resetStyles = useResetStyles();
    const styles = useStyles();
    const spacingStyle = state.spacing === 'small' ? styles.spacingSmall : styles.spacingMedium;
    state.root.className = (0, _react.mergeClasses)(swatchPickerRowClassNames.root, resetStyles, spacingStyle, state.root.className);
    return state;
}; //# sourceMappingURL=useSwatchPickerRowStyles.styles.js.map
